import { render } from "./GameLandingPage.vue?vue&type=template&id=85dfa284&scoped=true"
import script from "./GameLandingPage.vue?vue&type=script&lang=js"
export * from "./GameLandingPage.vue?vue&type=script&lang=js"

import "./GameLandingPage.vue?vue&type=style&index=0&id=85dfa284&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85dfa284"]])

export default __exports__